import { Badge } from "react-bootstrap";
import { investigationStatusBadge } from "./investigationSessions";

const InvestigationStatusBadge = ({ status }: { status: string }) => {
  const badge = investigationStatusBadge(status);
  return <Badge bg={badge.bg}>{badge.label}</Badge>;
};

export default InvestigationStatusBadge;
